import React from 'react'

const InputField = ({
  className,
  type = "text",
  label,
  value,
  onChange,
  error,
  placeholder
}) => (
  <label className={`flex flex-col ${className}`}>
    {label && <span className={`text-${error ? 'red-600' : 'gray-500'}`}>{label}</span>}

    <input
      className={`${error && 'text-red-600'}`}
      value={value}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      style={{
        border: error && '2px solid rgba(220, 38, 38)',
      }}
    />

    {error && <span className="text-sm text-red-600 font-light">{error}</span>}
  </label>
)

export default InputField
